import { render, staticRenderFns } from "./box-product-component.vue?vue&type=template&id=700438c4&lang=html&"
import script from "./box-product-component.vue?vue&type=script&lang=js&"
export * from "./box-product-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports